import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  queryReconciliationSuccess,
  queryReconciliationFailure,
} from '../actions';
import { queryReconciliation, QueryReconciliationResponse } from '../api';
import { TransactionTypeFilter } from '../models';
import { QueryReconciliationRequestAction } from '../types';

export function* queryReconciliationSaga(
  action: QueryReconciliationRequestAction
) {
  try {
    const { reportId, page, pageSize, transactionType, groupingType, filters } =
      action.payload;

    const response: QueryReconciliationResponse = yield call(
      queryReconciliation,
      reportId,
      page,
      pageSize,
      transactionType,
      groupingType,
      filters
    );
    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(
      queryReconciliationSuccess(
        response.data,
        transactionType as TransactionTypeFilter
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(queryReconciliationFailure());
  }
}
